
<template>
  <b-card header-tag="header" footer-tag="footer">
    <template v-slot:header>
      <h6 class="mb-0" v-if="showName == true">Temperature control ({{device.object}})</h6>
      <h6 class="mb-0" v-else>Temperature control</h6>
    </template>
    <b-button-toolbar aria-label="Toolbar with button groups and dropdown menu">
      <b-button-group class="mx-1">
        <b-button variant="outline-info" @click="setCool()">Cool</b-button>
        <b-button @click="setOff()">Off</b-button>
        <b-button variant="outline-danger" @click="setHeat()">Heat</b-button>
      </b-button-group>
    </b-button-toolbar>
    <br>
    <div class="ac-controls mt-3">
      <h6>AC Unit Configuration</h6>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label for="brandSelect">Brand</label>
            <b-form-select id="brandSelect" v-model="acBrand" :options="brandOptions" @change="setBrand"></b-form-select>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="modelSelect">Remote model</label>
            <b-form-select id="modelSelect" v-model="acModel" :options="modelOptions" @change="setModel"></b-form-select>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label for="fanPowerSelect">Fan Power</label>
            <b-form-select id="fanPowerSelect" v-model="acFanPower" :options="fanPowerOptions" @change="setFanPower"></b-form-select>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="lightToggle">LED Light</label>
            <b-form-checkbox id="lightToggle" v-model="acLight" switch @change="setLight"></b-form-checkbox>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label for="swingModeSelect">Swing Mode</label>
            <b-form-select id="swingModeSelect" v-model="acSwingMode" :options="swingModeOptions" @change="setSwingMode"></b-form-select>
          </div>
        </div>
      </div>
    </div>
    <hr>
    Press for half a second until you see a white ring to change the target temperature, and select cool or heat to send the command
    <br>
    <div id="container">
      <div id="thermostat"></div>
    </div>
  </b-card>
</template>
<style>
#thermostat {
  width: 25vmin;
  height: 25vmin;
  margin: 0 auto;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
.dial {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.dial.away .dial__ico__leaf {
  visibility: hidden;
}
.dial.away .dial__lbl--target {
  visibility: hidden;
}
.dial.away .dial__lbl--target--half {
  visibility: hidden;
}
.dial.away .dial__lbl--away {
  opacity: 1;
}
.dial .dial__shape {
  transition: fill 0.5s;
}
.dial__ico__leaf {
  fill: #13eb13;
  opacity: 0;
  transition: opacity 0.5s;
  pointer-events: none;
}
.dial.has-leaf .dial__ico__leaf {
  display: block;
  opacity: 1;
  pointer-events: initial;
}
.dial__editableIndicator {
  fill: white;
  fill-rule: evenodd;
  opacity: 0;
  transition: opacity 0.5s;
}
.dial--edit .dial__editableIndicator {
  opacity: 1;
}
.dial--state--off .dial__shape {
  fill: #222;
}
.dial--state--heating .dial__shape {
  fill: #e36304;
}
.dial--state--cooling .dial__shape {
  fill: #007af1;
}
.dial__ticks path {
  fill: rgba(255, 255, 255, 0.3);
}
.dial__ticks path.active {
  fill: rgba(255, 255, 255, 0.8);
}
.dial text {
  fill: white;
  text-anchor: middle;
  font-family: Helvetica, sans-serif;
  alignment-baseline: central;
}
.dial__lbl--target {
  font-size: 120px;
  font-weight: bold;
}
.dial__lbl--target--half {
  font-size: 40px;
  font-weight: bold;
  opacity: 0;
  transition: opacity 0.1s;
}
.dial__lbl--target--half.shown {
  opacity: 1;
  transition: opacity 0s;
}
.dial__lbl--ambient {
  font-size: 22px;
  font-weight: bold;
}
.dial__lbl--away {
  font-size: 72px;
  font-weight: bold;
  opacity: 0;
  pointer-events: none;
}
@font-face {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 300;
  font-stretch: normal;
  src: url(https://fonts.gstatic.com/s/opensans/v26/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsiH0B4gaVc.ttf)
    format("truetype");
}
#controls {
  font-family: Open Sans;
  background-color: rgba(255, 255, 255, 0.25);
  padding: 20px;
  border-radius: 5px;
  position: absolute;
  left: 50%;
  transform: translatex(-50%);
  margin-top: 20px;
}
#controls label {
  text-align: left;
  display: block;
}
#controls label span {
  display: inline-block;
  width: 200px;
  text-align: right;
  font-size: 0.8em;
  text-transform: uppercase;
}
#controls p {
  margin: 0;
  margin-bottom: 1em;
  padding-bottom: 1em;
  border-bottom: 2px solid #ccc;
}
.ac-controls {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 15px;
}
</style>
<script>
import { BROADCAST_ACTION, FETCH_DEVICE_PROPS } from "@/core/services/store/devices.module";
export default {
  name: "suitch-status-widget",
  components: {},
  props: {
    device: null,
    showName: {
      type: Boolean,
      default: false
    },
  },
  beforeDestroy() {
    // Unsubscribe from the store when the component is destroyed
    if (this.unsubscribe) {
      this.unsubscribe();
      console.log("kill_subscribe");
    }
  },
  mounted() {
    this.downloadData();
    this.unsubscribe = this.$store.subscribe((mutation, state) => {
      if (mutation.type == "setMessage") {
        // verify if the type of message is for this widget
        if (this.device != null 
        && state.realtime.last_message.type == "props" 
        && state.realtime.last_message.token == this.device.token) {
          // call again the action to get the status
          this.downloadData();
        }
      }
    });
    this.nest = new window.thermostatDial(
      document.getElementById("thermostat"),
      {
        onSetTargetTemperature: function(v) {
          console.log("temperature:", v);
        }
      }
    );
    this.nest.ambient_temperature = 24;
    this.nest.hvac_state = "off";
    this.nest.target_temperature = 22;
  },
  data() {
    return {
      unsubscribe: null,
      nest: null,
      acBrand: 0, // Default to RC5
      acModel: 1, // Default to model 1
      acFanPower: 0, // Default to Auto
      acLight: false, // Default to off (0)
      acSwingMode: -1, // Default to Off
      
      // Options for the dropdowns
      brandOptions: [
        { value: 1, text: 'RC5' },
        { value: 2, text: 'RC6' },
        { value: 3, text: 'NEC' },
        { value: 4, text: 'SONY' },
        { value: 5, text: 'PANASONIC' },
        { value: 6, text: 'JVC' },
        { value: 7, text: 'SAMSUNG' },
        { value: 8, text: 'WHYNTER' },
        { value: 9, text: 'AIWA_RC_T501' },
        { value: 10, text: 'LG' },
        { value: 11, text: 'SANYO' },
        { value: 12, text: 'MITSUBISHI' },
        { value: 13, text: 'DISH' },
        { value: 14, text: 'SHARP' },
        { value: 15, text: 'COOLIX' },
        { value: 16, text: 'DAIKIN' },
        { value: 17, text: 'DENON' },
        { value: 18, text: 'KELVINATOR' },
        { value: 19, text: 'SHERWOOD' },
        { value: 20, text: 'MITSUBISHI_AC' },
        { value: 21, text: 'RCMM' },
        { value: 22, text: 'SANYO_LC7461' },
        { value: 23, text: 'RC5X' },
        { value: 24, text: 'GREE' },
        { value: 25, text: 'PRONTO' },
        { value: 26, text: 'NEC_LIKE' },
        { value: 27, text: 'ARGO' },
        { value: 28, text: 'TROTEC' },
        { value: 29, text: 'NIKAI' },
        { value: 30, text: 'RAW' },
        { value: 31, text: 'GLOBALCACHE' },
        { value: 32, text: 'TOSHIBA_AC' },
        { value: 33, text: 'FUJITSU_AC' },
        { value: 34, text: 'MIDEA' },
        { value: 35, text: 'MAGIQUEST' },
        { value: 36, text: 'LASERTAG' },
        { value: 37, text: 'CARRIER_AC' },
        { value: 38, text: 'HAIER_AC' },
        { value: 39, text: 'MITSUBISHI2' },
        { value: 40, text: 'HITACHI_AC' },
        { value: 41, text: 'HITACHI_AC1' },
        { value: 42, text: 'HITACHI_AC2' },
        { value: 43, text: 'GICABLE' },
        { value: 44, text: 'HAIER_AC_YRW02' },
        { value: 45, text: 'WHIRLPOOL_AC' },
        { value: 46, text: 'SAMSUNG_AC' },
        { value: 47, text: 'LUTRON' },
        { value: 48, text: 'ELECTRA_AC' },
        { value: 49, text: 'PANASONIC_AC' },
        { value: 50, text: 'PIONEER' },
        { value: 51, text: 'LG2' },
        { value: 52, text: 'MWM' },
        { value: 53, text: 'DAIKIN2' },
        { value: 54, text: 'VESTEL_AC' },
        { value: 55, text: 'TECO' },
        { value: 56, text: 'SAMSUNG36' },
        { value: 57, text: 'TCL112AC' },
        { value: 58, text: 'LEGOPF' },
        { value: 59, text: 'MITSUBISHI_HEAVY_88' },
        { value: 60, text: 'MITSUBISHI_HEAVY_152' },
        { value: 61, text: 'DAIKIN216' },
        { value: 62, text: 'SHARP_AC' },
        { value: 63, text: 'GOODWEATHER' },
        { value: 64, text: 'INAX' },
        { value: 65, text: 'DAIKIN160' },
        { value: 66, text: 'NEOCLIMA' },
        { value: 67, text: 'DAIKIN176' },
        { value: 68, text: 'DAIKIN128' },
        { value: 69, text: 'AMCOR' },
        { value: 70, text: 'DAIKIN152' },
        { value: 71, text: 'MITSUBISHI136' },
        { value: 72, text: 'MITSUBISHI112' },
        { value: 73, text: 'HITACHI_AC424' },
        { value: 74, text: 'SONY_38K' },
        { value: 75, text: 'EPSON' },
        { value: 76, text: 'SYMPHONY' },
        { value: 77, text: 'HITACHI_AC3' },
        { value: 78, text: 'DAIKIN64' },
        { value: 79, text: 'AIRWELL' },
        { value: 80, text: 'DELONGHI_AC' },
        { value: 81, text: 'DOSHISHA' },
        { value: 82, text: 'MULTIBRACKETS' },
        { value: 83, text: 'CARRIER_AC40' },
        { value: 84, text: 'CARRIER_AC64' },
        { value: 85, text: 'HITACHI_AC344' },
        { value: 86, text: 'CORONA_AC' },
        { value: 87, text: 'MIDEA24' },
        { value: 88, text: 'ZEPEAL' },
        { value: 89, text: 'SANYO_AC' },
        { value: 90, text: 'VOLTAS' },
        { value: 91, text: 'METZ' },
        { value: 92, text: 'TRANSCOLD' },
        { value: 93, text: 'TECHNIBEL_AC' },
        { value: 94, text: 'MIRAGE' },
        { value: 95, text: 'ELITESCREENS' },
        { value: 96, text: 'PANASONIC_AC32' },
        { value: 97, text: 'MILESTAG2' },
        { value: 98, text: 'ECOCLIM' },
        { value: 99, text: 'XMP' },
        { value: 100, text: 'TRUMA' },
        { value: 101, text: 'HAIER_AC176' },
        { value: 102, text: 'TEKNOPOINT' },
        { value: 103, text: 'KELON' },
        { value: 104, text: 'TROTEC_3550' },
        { value: 105, text: 'SANYO_AC88' },
        { value: 106, text: 'BOSE' },
        { value: 107, text: 'ARRIS' },
        { value: 108, text: 'RHOSS' },
        { value: 109, text: 'AIRTON' },
        { value: 110, text: 'COOLIX48' },
        { value: 111, text: 'HITACHI_AC264' },
        { value: 112, text: 'KELON168' },
        { value: 113, text: 'HITACHI_AC296' },
        { value: 114, text: 'DAIKIN200' },
        { value: 115, text: 'HAIER_AC160' },
        { value: 116, text: 'CARRIER_AC128' },
        { value: 117, text: 'TOTO' },
        { value: 118, text: 'CLIMABUTLER' },
        { value: 119, text: 'TCL96AC' },
        { value: 120, text: 'BOSCH144' },
        { value: 121, text: 'SANYO_AC152' },
        { value: 122, text: 'DAIKIN312' },
        { value: 123, text: 'GORENJE' },
        { value: 124, text: 'WOWWEE' },
        { value: 125, text: 'CARRIER_AC84' },
        { value: 126, text: 'YORK' },
        { value: 127, text: 'BLUESTARHEAVY' }
      ],
      modelOptions: [
        { value: 1, text: 'Model 1' },
        { value: 2, text: 'Model 2' },
        { value: 3, text: 'Model 3' },
        { value: 4, text: 'Model 4' }
      ],
      fanPowerOptions: [
        { value: 0, text: 'Auto' },
        { value: 1, text: 'Min' },
        { value: 2, text: 'Low' },
        { value: 3, text: 'Medium' },
        { value: 4, text: 'High' },
        { value: 5, text: 'Max' },
        { value: 6, text: 'Medium High' }
      ],
      swingModeOptions: [
        { value: -1, text: 'Off' },
        { value: 0, text: 'Auto' },
        { value: 1, text: 'Highest' },
        { value: 2, text: 'High' },
        { value: 3, text: 'Middle' },
        { value: 4, text: 'Low' },
        { value: 5, text: 'Lowest' },
        { value: 6, text: 'Upper Middle' }
      ]
    };
  },
  methods: {
    downloadData() {
      if (this.device != null) {
        this.$store.dispatch(FETCH_DEVICE_PROPS, { device_token: this.device.token })
        .then((data) => {
          if (data == undefined || data == null) {
            // when null
          } else {
            data.forEach(element => {
              switch(element.command_data) {
                case "mode":
                  if (element.value == "off") {
                    this.nest.hvac_state = element.value;
                  } else {
                    this.nest.hvac_state = element.value + "ing";
                  }
                  break;
                case "temp":
                  this.nest.ambient_temperature = Number(element.value);
                  break;
                case "set_temp":
                  this.nest.target_temperature = Number(element.value);
                  break;
                case "brand":
                  this.acBrand = Number(element.value);
                  break;
                case "model":
                  this.acModel = Number(element.value);
                  break;
                case "fan_power":
                  this.acFanPower = Number(element.value);
                  break;
                case "leds":
                  this.acLight = Number(element.value) === 1;
                  break;
                case "swing_mode":
                  this.acSwingMode = Number(element.value);
                  break;
              }
            });
          }
        });
      }
    },
    setHeat() {
      this.nest.hvac_state = "heating";
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "heat:" + String(this.nest.target_temperature)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("The target temperature has been propagated", {
            title: `Result`,
            variant: "success",
            solid: true,
          });
        });
    },
    setCool() {
      this.nest.hvac_state = "cooling";
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "cool:" + String(this.nest.target_temperature)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("The target temperature has been propagated", {
            title: `Result`,
            variant: "success",
            solid: true,
          });
        });
    },
    setOff() {
      this.nest.hvac_state = "off";
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "off"
        })
        .then((data) => {
          data;
          this.$bvToast.toast("The device has gone off", {
            title: `Result`,
            variant: "success",
            solid: true,
          });
        });
    },
    // New methods for the additional controls
    setBrand() {
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "set_brand:" + String(this.acBrand)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("AC brand has been updated", {
            title: `Brand Updated`,
            variant: "success",
            solid: true,
          });
        });
    },
    setModel() {
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "set_model:" + String(this.acModel)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("AC model has been updated", {
            title: `Model Updated`,
            variant: "success",
            solid: true,
          });
        });
    },
    setFanPower() {
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "set_fan_power:" + String(this.acFanPower)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("Fan power has been updated", {
            title: `Fan Power Updated`,
            variant: "success",
            solid: true,
          });
        });
    },
    setLight() {
      const lightValue = this.acLight ? 1 : 0;
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "set_leds:" + String(lightValue)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("LED light setting has been updated", {
            title: `Light Updated`,
            variant: "success",
            solid: true,
          });
        });
    },
    setSwingMode() {
      this.$store
        .dispatch(BROADCAST_ACTION, { 
          token: this.device.token,
          secret: this.device.secret_token,
          command_data: "set_swing:" + String(this.acSwingMode)
        })
        .then((data) => {
          data;
          this.$bvToast.toast("Swing mode has been updated", {
            title: `Swing Mode Updated`,
            variant: "success",
            solid: true,
          });
        });
    }
  },
  watch: {
    device: function(oldval, newval) {
      oldval, newval;
      this.downloadData();
    },
  },
};
</script>
